import React, { useEffect, useState } from 'react';
import { Table } from "../../Components/DashboardTable";
import { BookingType } from '../../Components/Types';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import MobileBookingTable from './MobileBookingTable';
import DesktopBookingTable from './DesktopBookingTable';

type MyBookingsProps = {
    bookings: BookingType[][];
}
type ButtonType = {
    back: boolean;
    next: boolean;
}
const Pagination = styled.div`
   display:flex;
   justify-content:center;
`;
const PaginationLink = styled.p`
   color: var(--main-teal-color);
   cursor:pointer;
`;

function BookingsTable({ bookings }: MyBookingsProps) {
    const [visiblePage, setVisiblePage] = useState<number>(0);
    const [buttonsVisible, setButtonsVisible] = useState<ButtonType>({
        back: false,
        next: false
    });
    const maxPage = bookings && bookings.length - 1;
    const navigate = useNavigate();

    useEffect(() => {
        setButtonsVisible(prevState => ({...prevState, next: bookings.length > 1}))
    }, [bookings]);

    const backPage = () => {
        const buttonsState = { ...buttonsVisible };
        if (visiblePage > 0) {
            setVisiblePage(visiblePage - 1);
            buttonsState.next = true;
            buttonsState.back = visiblePage - 1 > 0;
        }
        else {
            buttonsState.back = false;
        }
        setButtonsVisible(buttonsState);
    }

    const nextPage = () => {
        const buttonsState = { ...buttonsVisible };
        if (maxPage == visiblePage) {
            buttonsState.next = false;
        }
        else {
            setVisiblePage(0);
            setVisiblePage(visiblePage + 1);
            buttonsState.back = true;
            buttonsState.next = visiblePage + 1 < maxPage;
        }
        setButtonsVisible(buttonsState);
        
    }

    const licenseCheck = (bookingId : number) => {
        return navigate("/LicenceCheck/" + bookingId);
    }

    const bookingPayments = (bookingId: number, vehicleName: string) => {
        navigate("/BookingPayments/" + bookingId + "/" + vehicleName.replaceAll(" ", ""))
    }

    const desktopView = useMediaQuery({
        query: '(min-width: 1050px)'
    });

    return (
        <>
            <Table>
                {desktopView ?
                    <DesktopBookingTable 
                        bookings={bookings} 
                        visiblePage={visiblePage}
                        licenseCheck={licenseCheck} 
                        bookingPayments={bookingPayments}
                    />
                    :
                    <MobileBookingTable 
                        bookings={bookings} 
                        visiblePage={visiblePage}
                        licenseCheck={licenseCheck} 
                        bookingPayments={bookingPayments}
                    />
                } 
            </Table>
            <Pagination>
            {buttonsVisible.back &&
                <PaginationLink onClick={() => backPage()}>Previous</PaginationLink>
            }
            {buttonsVisible.back && buttonsVisible.next &&
                <p>|</p>
            }
            {buttonsVisible.next &&
                <PaginationLink onClick={() => nextPage()}>Next</PaginationLink>
            }
            </Pagination>
        </>
    );
}
export default BookingsTable;
